import './styles.scss';
import React, {useState} from 'react';
import {Popover, Select, Tag, Tooltip} from "antd";
import {PlusOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {STRAPI_FILTERS} from "../../../global/utils/StrapiUtils";
import PSCApi from "../../../api/PSC/PSC.api";
import qs from 'qs';
import _ from 'lodash';
import {IPSC} from "../../../api/PSC/PSC.types";

interface Props {
    onChange?: (value: string[]) => void,
    value?: string[],
}

function PSCTags({onChange, value = []}: Props) {
    const [search, setSearch] = useState<string>();
    const [psc, setNaics] = useState<IPSC[]>();

    async function onSearch(text: string) {
        let codeParam = `code_${STRAPI_FILTERS.CONTAINS}`;
        let descriptionParam = `description_${STRAPI_FILTERS.CONTAINS}`;
        let query = {
            _where: {
                _or: [{[codeParam]: text}, {[descriptionParam]: text}]
            }
        }
        let queryString = qs.stringify(query);
        let curNaics = await PSCApi.searchNaicsCodes(queryString);
        if (curNaics) {
            setSearch(text);
            setNaics(curNaics);
        }
    }

    const [inputVisible, setInputVisible] = useState(false);

    function handleClose(removedTag) {
        const curTags = value.filter(tag => tag !== removedTag);
        onChange(curTags);
    }

    function showInput() {
        setInputVisible(true);
    }


    function getListOfDescriptions(rawDescription) {
        return rawDescription.split("::");
    }

    function renderAllDescriptions(rawDescription) {
        let descriptions = getListOfDescriptions(rawDescription);
        return (
            <div className='all-descriptions'>
                {descriptions.map((description, index) => {
                    let replaced = description.replace(new RegExp(search, 'gi'), `<b>${search}</b>`)
                    return (<div key={index} dangerouslySetInnerHTML={{__html: replaced}}/>)
                })}
            </div>
        )
    }

    function onSelect(selected: string) {
        let curValue = [...value];
        if (curValue.indexOf(selected) === -1) {
            curValue.push(selected);
        }
        onChange(curValue);
        setInputVisible(false);
    }

    let debouncedSearch = _.debounce(onSearch, 300);

    function onKeyDown(e) {
        if (e.key === "Escape") {
            setInputVisible(false);
        }
    }

    return (
        <>
            {value && value.map((tag) => {

                const isLongTag = tag.length > 20;

                const tagElem = (
                    <Tag className="edit-tag" key={tag} closable onClose={() => handleClose(tag)}>
                      <span>
                        {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                      </span>
                    </Tag>
                );
                return isLongTag ? (
                    <Tooltip title={tag} key={tag}>
                        {tagElem}
                    </Tooltip>
                ) : (
                    tagElem
                );
            })}
            {inputVisible && (
                <Select showSearch value={undefined} onChange={onChange} onSearch={debouncedSearch}
                        className='psc-search-select' onSelect={onSelect} onKeyDown={onKeyDown}
                        size='large' placeholder='Search by code or description' filterOption={false}
                        dropdownClassName='psc-search-select'>
                    {psc && psc.map(s => (
                        <Select.Option key={s.code} value={s.code}>
                            <Popover title={`PSC Code: ${s.code} Descriptions`} placement='topRight'
                                     content={renderAllDescriptions(s.description)} overlayStyle={{zIndex: 9999}}>
                                <QuestionCircleOutlined style={{marginRight: 9}}/>
                            </Popover>
                            <span className='psc-code'>{s.code}</span> - {getListOfDescriptions(s.description)[0]}
                        </Select.Option>
                    ))}
                </Select>
            )}
            {!inputVisible && (
                <Tag className="site-tag-plus" onClick={showInput}>
                    <PlusOutlined/> Add PSC Code
                </Tag>
            )}
        </>
    )

}

export default PSCTags;